import { Box, Typography, useTheme } from "@material-ui/core";
import { formatMoney } from "../../../../../../../utils/formaters";
import React, { useContext } from "react";
import {
  formatDateReadable,
  Locale,
  PaymentPlanLineStatus,
} from "@nemuru-eng/js-api-client";
import Text from "../../../../../../shared/components/Text";
import { AuthContext } from "../../../../../../../contexts/AuthContext";

export const PaymentPlanLineCard = ({ paymentPlanLine, selected = false }) => {
  const {
    state: { loanOnAppStart },
  } = useContext(AuthContext);

  const { customBorderRadius } = useTheme();

  const hasSetupFeeOfTypeUpfront =
    loanOnAppStart.loan_conditions.loan_calculator?.setup_fee?.type ===
      "type_upfront" &&
    loanOnAppStart.loan_conditions.loan_calculator?.setup_fee?.fee_amount
      .amount > 0;

  return (
    <Box
      bgcolor={"grey.50"}
      borderRadius={customBorderRadius.paper}
      border={selected ? "solid 1px" : "none"}
      borderColor={"grey.400"}
    >
      <Box px={2} py={1} display={"flex"} justifyContent={"space-between"}>
        <Box display={"flex"} alignItems={"center"} color={"text.title"}>
          <Box
            p={"4px"}
            mr={"12px"}
            borderRadius={"100%"}
            color={
              paymentPlanLine.status === PaymentPlanLineStatus.PAID
                ? "info.contrastText"
                : "grey.400"
            }
            bgcolor={
              paymentPlanLine.status === PaymentPlanLineStatus.PAID
                ? "info.main"
                : "grey.200"
            }
          >
            <i className={"material-icons-outlined"} style={{ fontSize: 18 }}>
              {paymentPlanLine.status === PaymentPlanLineStatus.PAID
                ? "check"
                : "schedule"}
            </i>
          </Box>
          <Box>
            <Typography
              variant={"body2"}
              component={"p"}
              style={{ marginBottom: 2 }}
            >
              <strong>
                {paymentPlanLine.quota_number === 0 &&
                hasSetupFeeOfTypeUpfront ? (
                  <Text
                    tId={"QUOTA_AND_SETUP_FEE_WITH_NUMBER"}
                    dynamicDataTexts={[paymentPlanLine.quota_number + 1]}
                  />
                ) : (
                  <Text
                    tId={"QUOTA_WITH_NUMBER"}
                    dynamicDataTexts={[paymentPlanLine.quota_number + 1]}
                  />
                )}
              </strong>
            </Typography>
            <Typography
              variant={"caption"}
              color={"textSecondary"}
              component={"p"}
            >
              {formatDateReadable(
                new Date(paymentPlanLine.due_date),
                Locale.ES_ES
              )}
            </Typography>
          </Box>
        </Box>
        <Box display={"flex"} flexDirection={"column"} alignItems={"flex-end"}>
          <Typography
            variant={"body2"}
            component={"p"}
            align={"right"}
            style={{ marginBottom: 2 }}
          >
            <strong>{formatMoney(paymentPlanLine.quota.amount, 2)}</strong>
          </Typography>
          <Box
            color={
              paymentPlanLine.status === PaymentPlanLineStatus.PAID
                ? "info.main"
                : "text.secondary"
            }
          >
            <Typography variant={"caption"} align={"right"}>
              <Text
                tId={`PAYMENT_PLAN_LINE_STATUS_${paymentPlanLine.status}`}
              />
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
